var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide"}},[_c('div',{staticClass:"content-transition h-full flex column content-between col-grow-1"},[_c('div',{staticClass:"fade-in-down h-full flex column content-between w-full"},[_c('div',{staticClass:"w-full flex col-grow-1 column content-center items-center h-full justify-center"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }